export const getDomain = (location) => {
	const { hostname, port, protocol } = location;
	return `${protocol}//${hostname}${port !== '' ? `:${port}` : ''}`;
};

/**
 *
 * @param {*} search location.search
 * @param  {...string} params `key=value&key=value`
 * @returns search
 */
export const createLocationSearch = (search = '', params = '') => {
	let result = search;

	params.split('&').forEach((param) => {
		const [key, value] = param.split('=');

		if (result) {
			const regExp = new RegExp(`(${key})=\\w+`, 'g');
			result = `${result.indexOf(key) !== -1 ? result.replace(regExp, `$1=${value}`) : result.concat(`&${key}=${value}`)}`;
		} else {
			result = `?${key}=${value}`;
		}
	});

	return result;
};

export const getPathname = (url) => {
	const anchorElement = document.createElement('a');
	anchorElement.href = url;
	return anchorElement.pathname;
};
